import { closeActivity, type IActivity } from "@/api/Activities";
import CalendarDeleteIcon from "@medoma/components/icons/CalendarDeleteIcon";
import { activityStatusSchema } from "@medoma/models/activities";
import { Trans, useLingui } from "@lingui/react/macro";
import { Text } from "@medoma/components/Text/Text";
import { useMutation } from "@tanstack/react-query";
import { deducedError, displayErrorMessageAlert } from "@/Utils/ErrorUtils";
import { ActionCardButton } from "@/components/ActionCard/ActionCard";

export const CloseActivitySeriesButton = ({
  id,
  status,
  onSuccess,
}: Pick<IActivity, "id" | "status"> & {
  onSuccess: () => Promise<void>;
}) => {
  const { t } = useLingui();

  const { mutate, isPending } = useMutation({
    mutationFn: () => closeActivity(id),
    onError: (error) => {
      displayErrorMessageAlert(
        `${t`Det gick inte att stänga aktiviteten.`} ${deducedError(error)}`,
      );
    },
    onSuccess: async () => {
      await onSuccess();
    },
  });

  if (status !== activityStatusSchema.enum.active) {
    return (
      <Text element="div" size="small">
        <Trans>Aktivitetsserien är avslutad</Trans>
      </Text>
    );
  }

  return (
    <ActionCardButton
      icon={<CalendarDeleteIcon />}
      title={t`Avsluta hela serien`}
      onClick={() => {
        const confirmed = window.confirm(
          t`Alla framtida aktivitetstillfällen kommer att tas bort. Åtgärden går inte att ångra.`,
        );
        if (confirmed) {
          mutate();
        }
      }}
      disabled={isPending}
    />
  );
};
